import { UploadOutlined } from '@ant-design/icons'
import { FileDoneOutlined } from '@ant-design/icons'
import { Col, Row, Upload } from 'antd'
import { RcFile, UploadFile } from 'antd/lib/upload/interface'
import { KUploadProps } from 'app/components/Modules/Form/typing'
import Button from 'app/components/UI-Elements/General/Button'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { useCreate, useIndex } from 'app/lib/hooks/useApi'
import { useEffect, useState } from 'react'
import * as React from 'react'

const KUpload: React.FC<KUploadProps> = ({
  showRemoveIcon,
  document,
  params,
  listType = 'text',
  ...others
}) => {
  const {
    response: { data },
    loading,
    execute
  } = useIndex<IDocument>(RecordType.document)
  const { loading: uploading, execute: create } = useCreate<FormData>(RecordType.document)
  const { createFormData } = ToolBox.useFormTools()
  const { tButtonTitle } = ToolBox.useString()
  const [fileList, setFileList] = useState([])

  useEffect(() => {
    params && execute(params)
  }, [])
  useEffect(() => {
    setFileList(data)
  }, [data])

  const uploadAction = async (file: RcFile): Promise<void> => {
    const response = await create(createFormData({ file, ...document }))
    setFileList([...fileList, response])
  }

  const onPreview = async (file: UploadFile<IDocument>) => window.open(file.url)

  return (
    <Upload
      customRequest={({ file }) => uploadAction(file as RcFile)}
      listType={listType}
      fileList={fileList}
      iconRender={() => <FileDoneOutlined />}
      showUploadList={{ showRemoveIcon }}
      onPreview={onPreview}
      {...others}>
      <Choose>
        <When condition={listType === 'text'}>
          <Button
            className="full-width"
            loading={loading || uploading}
            icon={<UploadOutlined />}
            title={tButtonTitle({ recordType: RecordType.document, action: 'upload' })}
          />
        </When>
        <Otherwise>
          <Row align="middle" justify="center" className="full-width">
            <Col>
              <UploadOutlined className="mr-2" />
              <span>{tButtonTitle({ recordType: RecordType.document, action: 'upload' })}</span>
            </Col>
          </Row>
        </Otherwise>
      </Choose>
    </Upload>
  )
}

export default KUpload
